<template>
  <m4-input ref="iban_field" v-bind="$attrs" v-model="computedValue" type="text" :class="classes"></m4-input>
</template>

<script>
import valueProp from "../../../utils/valueProp.js";

export default {
  name: "M4IbanField",
  mixins: [valueProp],
  data() {
    let value = this.modelValue ? this.modelValue : this.value;
    return {
      newValue: value ? this.ibanFormat(value) : "",
      basicInput: null
    };
  },
  props: {
    modelValue: {
      type: [String, Number]
    }
  },
  emits: ["update:modelValue"],
  mounted() {
    this.basicInput = this.$refs.iban_field.$refs.inputElm;
  },
  computed: {
    classes() {
      let classes = ["iban-field"];
      return classes;
    },
    computedValue: {
      get() {
        return this.newValue;
      },
      set(value) {
        let cursorPos = this.basicInput.selectionStart;
        let plusChars = this.newValue.length < value.length;
        this.newValue = this.ibanFormat(value);
        this.$emit("update:modelValue", value);

        this.$nextTick(function () {
          let div = cursorPos - Math.floor(cursorPos / 5) * 5;
          if (cursorPos > 1 && div === 0 && plusChars) {
            cursorPos = cursorPos + 1;
          }
          this.basicInput.setSelectionRange(cursorPos, cursorPos);
          this.basicInput.focus();
        });
      }
    }
  },
  methods: {
    ibanFormat(value) {
      value = value.replaceAll(" ", "").split("");
      value = value.map((char, i) => {
        return i % 4 == 0 && i > 0 ? " " + char : char;
      });

      return value.join("");
    }
  },
  watch: {
    value(value) {
      this.newValue = value;
    },
    modelValue(value) {
      this.newValue = value;
    }
  }
};
</script>
